import { LENSES, ZUSTAND_TEXT, zellZustand, type LensKey } from '../../lib/lenses'
import { urteilVon, type Idea } from '../../services/qualyz'

interface Props {
  idea: Idea
  /** sm: nur Kuerzel (Listen, Startseite) · md: Kuerzel und Punkte (Tabelle) */
  groesse?: 'sm' | 'md'
  /** Linsen, die in die Konviktion zaehlen. Andere werden abgeblendet, nicht versteckt. */
  gewaehlt?: readonly LensKey[] | null
}

/**
 * Das Kernbauteil: die sieben Urteile eines Titels nebeneinander.
 *
 * Man liest daran die "Form" einer Aktie -- welche Blickwinkel sie tragen
 * und welche nicht. Reihenfolge ist ueberall Q · M · E · C · L · I · S.
 */
export default function LensBand({ idea, groesse = 'md', gewaehlt = null }: Props) {
  return (
    <div className={`q-band q-band--${groesse}`} role="list" aria-label="Urteile der sieben Linsen">
      {LENSES.map((linse) => {
        const { punkte, urteil, abdeckung } = urteilVon(idea, linse.key)
        const zustand = zellZustand(urteil, abdeckung)
        const abgeblendet = gewaehlt !== null && !gewaehlt.includes(linse.key)
        const beschreibung =
          zustand === 'na'
            ? `${linse.label}: kein Signal (zu wenig Daten)`
            : `${linse.label}: ${ZUSTAND_TEXT[zustand]}, ${Math.round(punkte)} Punkte`
        return (
          <div
            key={linse.key}
            role="listitem"
            className={`q-cell q-cell--${zustand}${abgeblendet ? ' is-dim' : ''}`}
            title={abgeblendet ? `${beschreibung} · zählt nicht in die Konviktion` : beschreibung}
            aria-label={beschreibung}
          >
            <span className="q-cell-code">{linse.code}</span>
            {groesse === 'md' && (
              <span className="q-cell-score">{zustand === 'na' ? '–' : Math.round(punkte)}</span>
            )}
          </div>
        )
      })}
    </div>
  )
}
